import axios from 'axios';

export const getIPAddressValidity = async () => {
  return axios.get('/api/risk-engine/ip-address');
};

export const getCryptoAddressValidity = async () => {
  return axios.post('/api/risk-engine/crypto-address');
};
